<template>
  <div>
    <mtd-header height="48px">
      <div class="title">{{ $getText('operation_task_alarm', '数据安全运营平台') }}</div>
      <div class="user-name" style="margin-right: 10px;">
        <mtd-dropdown trigger="hover">
          <mtd-button type="text" style="padding:0;width:22px; min-width: 22px;">
            <img class="user-name-img" :src="login_user.avatar">
          </mtd-button>
          <mtd-dropdown-menu slot="dropdown" class="platform-user-dropdown">
            <mtd-dropdown-menu-item>
              <div class="platform-user-info">
                <img class="platform-user-img" :src="login_user.avatar">
                <span class="platform-user-name">{{login_user.username}}</span>
                <span class="platform-user-name">{{login_user.mis_id}}</span>
              </div>
            </mtd-dropdown-menu-item>
            <mtd-dropdown-menu-item>
              <div style="padding: 4px 12px; color: rgba(0, 0, 0, 0.84);">
                <mtd-button type="text" icon="mtdicon mtdicon-log-out" @click="logout">{{ $getText('operation_btn_logout', '退出') }}</mtd-button>
              </div>
            </mtd-dropdown-menu-item>
          </mtd-dropdown-menu>
        </mtd-dropdown>
      </div>
    </mtd-header>
    <div style="padding: 36px">
      <mtd-row class="height-64 line-height-64">
        <mtd-col :span="21" class="height-full">
          <span class="page-head-title">{{ $getText('operation_menu_logout_index', '待办事项') }}</span>
        </mtd-col>
        <a href="https://km.sankuai.com/collabpage/2257670643" target="_blank">
          <mtd-button :span="3" class="height-full" type="text" icon="mtdicon mtdicon-question-circle-o" style="float: right">
            <span>{{ $getText('operation_alarm_btn_view_faq', '告警处理FAQ')}}</span>
          </mtd-button>
        </a>
      </mtd-row>
      <mtd-row>
        <mtd-col :span="24">
          <mtd-table :data="reminders_list" @row-click="show_detail_table">
            <mtd-table-column prop="createTime" :label="text_data.column_time" width="140">
              <template slot-scope="scope">
                {{scope.row.createTime|dateTimeFormat}}
              </template>
            </mtd-table-column>
            <mtd-table-column prop="beAlertedMis" :label="text_data.column_mis" show-overflow-tooltip width="140"/>
            <mtd-table-column prop="attributionBusiness" :label="text_data.column_org" width="150" show-overflow-tooltip/>
            <mtd-table-column prop="content" :label="text_data.column_detail" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ is_en ? (scope.row.enContent || scope.row.content) : scope.row.content }}
              </template>
            </mtd-table-column>
            <mtd-table-column prop="rowStatus" :label="text_data.column_status" width="220">
              <template slot-scope="scope">
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 1">
                  {{ $getText('operation_alarm_status_only_reminder', '仅告警提醒') }}
                </mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 2">
                  {{ $getText('operation_alarm_status_self_feedback', '待本人反馈') }}
                </mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 3">
                  {{ $getText('operation_alarm_status_supersivor_confirm', '待相关方确认') }}
                </mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 6">
                  {{ $getText('operation_alarm_status_sec_recheck', '待信安复核') }}
                </mtd-tag>
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 9">
                  {{ $getText('operation_alarm_status_finished', '已完成') }}
                </mtd-tag>
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus === 100">
                  {{ $getText('operation_alarm_status_finished', '已完成') }}
                </mtd-tag>
              </template>
            </mtd-table-column>
            <mtd-table-column :label="text_data.column_operate" width="120">
              <template slot-scope="scope">
                <mtd-button type="text" size="small" @click="show_detail(scope.row.id)" style="color: #0a70f5">
                  {{ $getText('operation_alarm_link_view_detail', '查看详情') }}
                </mtd-button>
              </template>
            </mtd-table-column>
          </mtd-table>
          <div style="text-align: right;margin-top: 12px;">
            <mtd-pagination size="small" :total="pagination.total" :current-page="pagination.current_page"
                            :page-size="pagination.page_size" style="display: inline-block;"
                            @change="handlePaginationChange"/>
          </div>
        </mtd-col>
      </mtd-row>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import sso from '@/utils/sso'

  export default {
    name: "index",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      is_en() {
        return this.$i18nClient.getCurrentLocale() === 'en';
      }
    },
    data() {
      return {
        reminders_list: [],
        pagination: {
          total: 125,
          current_page: 1,
          page_size: 10,
        },
        text_data: {
          column_time: '告警时间',
          column_mis: '',
          column_alarm_name: '告警名称',
          column_status: '告警状态',
          column_cc: '抄送人',
          column_org: '归属业务',
          column_detail: '告警详情',
          column_description: '说明',
          column_operate: '操作',
          add_cc_title: '添加抄送人',
          cc_list: '抄送人列表',
          input_mis_tips: '请输入MIS'
        }
      }
    },
    mounted: function () {
      this.text_data.column_time = this.$getText('operation_alarm_column_time', '告警时间');
      this.text_data.column_mis = this.$getText('operation_alarm_column_mis', '当事人账号');
      this.text_data.column_alarm_name = this.$getText('operation_alarm_column_alarm_name', '告警名称');
      this.text_data.column_status = this.$getText('operation_alarm_column_status', '告警状态');
      this.text_data.column_cc = this.$getText('operation_alarm_column_cc', '抄送人');
      this.text_data.column_org = this.$getText('operation_alarm_column_org', '归属业务');
      this.text_data.column_detail = this.$getText('operation_alarm_column_detail', '告警详情');
      this.text_data.column_description = this.$getText('operation_alarm_column_description', '说明');
      this.text_data.column_operate = this.$getText('operation_alarm_column_operate', '操作');

      this.init_table();
    },
    methods: {
      ...mapActions([
        'api_query_blocking_reminders',
      ]),
      async init_table() {
        let params = {pageNum: this.pagination.current_page, limit: this.pagination.page_size};
        let response = await this.api_query_blocking_reminders(params);
        let result = response.data;
        this.reminders_list = result.items;
        this.pagination.total = result.tn;
      },
      logout() {
        sso.logout();
      },
      show_detail_table(event) {
        this.show_detail(event.row.id);
      },
      show_detail(id) {
        this.$router.push('/alarm/' + id);
      },
      handlePaginationChange(current){
        this.pagination.current_page = current;
        this.init_table();
      }
    }
  }
</script>

<style>
  @import "../../../styles/main-container.css";
  @import "../../../styles/public.css";

  .mtd-table-cell {
    font-size: 12px;
  }

  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }
  .platform-user-dropdown .mtd-dropdown-menu-item {
    padding: 0;
  }

  .platform-user-dropdown .platform-user-info {
    padding: 8px 12px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;
  }

  .platform-user-dropdown .platform-user-info .platform-user-img {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    vertical-align: middle;
    position: absolute;
    top: 17px;
  }

  .platform-user-dropdown .platform-user-info .platform-user-name {
    margin-left: 36px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    display: block;
    line-height: 22px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    cursor: pointer;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
    height: 48px;
    line-height: 48px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
    margin-right: 4px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    vertical-align: middle;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
    background-color: #f7f7f7;
  }
</style>
